function inputTel(inp, callback, mobile_only) {
	
	let prefix = '+7';
	let rawlen = 10;
	let tr = {};
	tr[0] = ' (';
	tr[3] = ') ';
	tr[6] = ' ';
	tr[8] = ' ';

	function rawize(s, mobileonly) {
		s = s.replace(/[^0-9]/g, '');
		//console.log("rawize", s);
		if (mobileonly) {
			if (s[1] === '7') {
				s = s.substring(1);
			}
			if (s[1] !== '9') {
				s = '+7';
			}
		}
		if (s[0] === '8') {
			s = '+7' + s.substring(1);
		}
		if (s[0] === '7') {
			s = '+7' + s.substring(1);
		}
		if (s.length === '18') {
			s = s.substring(0, 17);
		}

		//проверка начла ввода телефона	
		if (s[2] === "+") {
			s = s.substring(3);
		}
		if ((s[2] === '8' && s[3] === "9") || (s[2] === '7' && s[3] === '9')) {
			s = s.substring(3);
		}
		return s.replace(RegExp('^' + prefix.replace('+', '\\+')), '').replace(/\D/g, '').substring(0, 10);
	}



	function parse(el) {
		var mobileonly = false;
		if (typeof el.dataset.inputtelMobileonly !== "undefined" && el.dataset.inputtelMobileonly === "true") {
			mobileonly = true;
		}
		var raw = rawize(el.value, mobileonly);
		if (raw.length === 11 && raw.substr(0, 2) === "88") {
			raw = raw.substr(1);
		}
		var ret = '';
		for (var i = 0; i < raw.length; i++) {
			ret = ret + (tr[i] ? tr[i] : '') + raw[i];
		}
		var ss = el.selectionStart;
		el.value = prefix + ret;
		var callback = el.inputtel_callback;
		if (callback) {
			var eqals = false;
			if (el.dataset.oldval != "undefined" && el.dataset.oldval == prefix + raw) {
				eqals = true;
			}
			callback(rawlen == raw.length, prefix + raw, eqals, el);
		}
	}

	if (typeof inp == 'string') {
		var ar = document.querySelectorAll(inp);
		for (var i = 0; i < ar.length; i++) {
			inputTel(ar[i], callback);
		}
	}

	if (inp.target && getCursorPosition(inp.target) <= prefix.length) {
		setCursorPosition(inp.target, Math.max(prefix.length, inp.target.value.length));
	}
	if (inp.jquery) {
		for (var i = 0; i < inp.length; i++) {
			inputTel(inp[i], callback);
		}
	}

	if ("" + inp == '[object HTMLInputElement]') {
		inp.addEventListener('keydown', inputTel);
		inp.addEventListener('keyup', inputTel);
		inp.addEventListener('change', inputTel);
		inp.addEventListener('blur', inputTel);
		inp.addEventListener('focus', inputTel);
		//input похож на change, но отрабатывает сразу
		inp.addEventListener('input', inputTel);
		inp.addEventListener('click', inputTel);
		inp.addEventListener('touchmove', inputTel);

		if (inp.type !== "tel") {
			inp.type = "tel";
		}

		if (callback) {
			inp.inputtel_callback = callback;
		}

		parse(inp);
		if (inp.value == prefix) {
			inp.value = '';
		}
		return true;
	}

	if (inp.type == 'focus') {
		if (inp.target.value == '') {
			inp.target.value = prefix;
		}
	}
	if (inp.type == 'blur') {
		if (inp.target.value == prefix) {
			inp.target.value = '';
		}
	}
	if (inp.type == 'change') {
		//console.log('change;');
		parse(inp.target);
		return true;
	}
	if ((inp.type == 'keyup')) {
		//console.log(inp.key)
		parse(inp.target);
		//console.log();
	}
	if (inp.type == 'keydown') {
		iic = inp;
		if (inp.keyCode == 8) {
			if (inp.target.value == prefix) {
				inp.preventDefault();
				return false;
			}
		}
		if (inp.key && inp.key.length > 1) {
			//"Backspace" и т.п.
			return true;
		}

		if (!/^\d$/.test(inp.key) && !inp.ctrlKey) {
			//не принимаем не цифры
			//console.log("FEFE");
			inp.preventDefault();
			return false;
		}

		if (rawize(inp.target.value).length >= rawlen && inp.target.selectionEnd == inp.target.selectionStart && !inp.ctrlKey) {
			//если все уже ввели и нет селекта
			inp.preventDefault();
			return false;
		}
	}
}
function getCursorPosition(element) {
	var el = $(element).get(0);
	var pos = 0;
	if ('selectionStart' in el) {
		pos = el.selectionStart;
	} else if ('selection' in document) {
		el.focus();
		var Sel = document.selection.createRange();
		var SelLength = document.selection.createRange().text.length;
		Sel.moveStart('character', -el.value.length);
		pos = Sel.text.length - SelLength;
	}
	return pos;
}
function setCursorPosition(element, position) {
	var el = $(element).get(0);
	if ('selectionStart' in el) {
//		el.focus();
		el.setSelectionRange(position, position);
	} else if (el.createTextRange) {
		var range = el.createTextRange();
		range.move('character', position);
		range.select();
	}
}

/**
 * Дает ввести только цифры, ограничивает их длину ввода и производит валидацию при вводе
 * На основе проверки ввода присваивает css класс valid/invalid
 * @param {type} config - объект с параметрами
 * @returns {Boolean}
 */
function inputNum(config = {}) {
	const {
		inp, // элемент/элементы который найдется по querySelectorAll или jquery-объект (или просто один dom элемент)
		len, // длина ввода
		validateFunc, // функция валидации (ее можно не передавать)
		callback, // колбек, срабатывающий в случае успешного ввода символа
		forceReinit = false, // перевешивание обработчиков событий (например, при клонировании и повторном вызове)
		simpleValidation = false //проверка только на ввод цифр до определенной длины (например, если проверки уже определны в другом месте или не нужны)
	} = config;
	
	try {
		if (!inp) {
			console.warn('inputNum: передан невалидный элемент', inp);
			return false;
		}

		if (typeof inp === 'string') {
			var ar = document.querySelectorAll(inp);
			for (let i = 0; i < ar.length; i++) {
				inputNum({ ...config, inp: ar[i] }); // перезаписываем inp в config на один элемент и повторно вызываем
			}
			return true;
		}

		if (inp.jquery) {
			for (let j = 0; j < inp.length; j++) {
				inputNum({ ...config, inp: inp[j] }); // перезаписываем inp в config на один элемент и повторно вызываем
			}
			return true;
		}

		if (!(inp instanceof HTMLInputElement)) { // если не html то возвращаем
			console.warn('inputNum: передан невалидный элемент', inp);
			return false;
		}

		if(!forceReinit) {
			if (inp.dataset.inputNum === 'true') { 
				// Чтобы не вешать обработчики дважды (если вдруг повторные вызовы)
				return true;
			}
			
			inp.dataset.inputNum = 'true';
		}

		['keydown', 'keyup', 'change', 'blur', 'focus', 'input'].forEach(event => {
			inp.addEventListener(event, handler);
		});
		parse(inp);
		
		return true;
	} catch(e) {
		console.error("Ошибка в inputNum\n элемент" + inp + "\n Ошибка: \n" + e);
		return false;
	}
	
	function rawize(s) {
		return s.replace(/\D/g, '');
	}
	
	function handler(e) {
		if (e.type === 'change') {
			parse(e.target);
			return true;
		}
		if (e.type === 'keyup') {
			parse(e.target);
		}
		if (e.type === 'keydown') {
			if (e.keyCode === 8) {
				//"Backspace"
				if (e.target.value === '') {
					//удалили все, больше не удаляет
					e.preventDefault();
					return false;
				}
			}
			if (e.key && e.key.length > 1) {
				//"Backspace" и т.п.
				return true;
			}

			if (!/^\d$/.test(e.key) && !e.ctrlKey) {
				//не принимаем не цифры
				e.preventDefault();
				return false;
			}
			if (rawize(e.target.value).length >= len && e.target.selectionEnd === e.target.selectionStart && !e.ctrlKey) {
				//если все уже ввели и нет селекта
				e.preventDefault();
				return false;
			}
		}
		
		// постобработка, чтобы не могли вставить из буфера лишние значения
		if (e.target.value.length >= len) {
			const formattedVal = rawize(e.target.value); // форматируем
			const truncatedValue = formattedVal.slice(0, len); //обрезаем
			e.target.value = truncatedValue;
			return false;
		}
	}
	
	function parse(el) {
		var raw = rawize(el.value);
		el.value = raw;
		var validate = false;
		if(!simpleValidation) { // если валидация не простая то дальше определяем действия
			if (raw.length > 0) {
				if (validateFunc === undefined) {
					el.classList.toggle("validate", true);
					el.classList.toggle("invalid", false);
				} else {
					if(typeof validateFunc !== 'function') {
						throw new Error("Валидация должна быть функцией");
					}
					validate = validateFunc(raw);
					if (validate) {
						el.classList.toggle("validate", true);
						el.classList.toggle("invalid", false);

					} else {
						el.classList.toggle("validate", false);
						el.classList.toggle("invalid", true);
					}
				}
			} else {
				el.classList.toggle("validate", false);
				el.classList.toggle("invalid", false);
			}
		}
		if (callback) {
			var eqals = false;
			if (el.dataset.oldval !== "undefined" && el.dataset.oldval === raw) {
				eqals = true;
			}
			callback(validate, raw, eqals, el);
		}
	}
}

document.addEventListener('DOMContentLoaded', function() { 
	inputTel('.phone');
	
	//Валидация ИНН Физика
	inputNum({
		inp: '.innFiz[name="inn"]', 
		len: 12, 
		validateFunc: (inn) => validateInn(inn, 'fiz') // тут передаем тип доп параметром
	});

	//Валидация ИНН Юрика
	inputNum({
		inp: '.innUr[name="inn"]', 
		len: 10, 
		validateFunc: (inn) => validateInn(inn, 'ur') // тут передаем тип доп параметром
	});

	//Валидация ИНН (без определенного типа)
	//если не валидировали отдельно как физика или юрика (выше), то применится общая валидация.
	inputNum({
		inp: '.inn', 
		len: 12, 
		validateFunc: validateInn
	});

	// Валидация ОГРНИП
	inputNum({
		inp: '.ogrnip[name="ogrn"]', 
		len: 15, 
		validateFunc: validateOgrnip
	});

	// Валидация ОГРН
	inputNum({
		inp: '.ogrn[name="ogrn"]', 
		len: 13, 
		validateFunc: validateOgrn
	});

	//Валидация СНИЛС
	inputNum({
		inp: '.snils[name="snils"]', 
		len: 11, 
		validateFunc: validateSnils
	});

	//Валидация КПП
	inputNum({
		inp: '.kpp[name="kpp"]', 
		len: 9, 
		validateFunc: validateKPP
	});

	//Валидация РС
	inputNum({
		inp: '.rs[name="rs"]', 
		len: 20,
		validateFunc: function (rs) {
			const bik = document.querySelector('.bik');
			if (!bik) {
				console.warn("inputNum: .rs — не найден элемент .bik для валидации");
				return true; // проверка просто не будет работать
			}

			const bikVal = bik.value;
			if (!bikVal) { // пока бик пустой не подсвечиваем
				return true;
			}

			return validateRs(rs, bikVal); // добавляем доп. параметр перед вызововм валидации
		}
	});

	// Валидация почтового индекса
	inputNum({
		inp: '[name="postal_index"]',
		len: 9, // везде не больше 9ти
		//validateFunc: validatePostalIndex, // не нужно показывать 
		simpleValidation: true // простая валидация (на длину и ввод только цифр)
	});

});


